import { Plus, Trash2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { FieldError, errCls } from "@/lib/validate";

export const SIGNATORY_ROLES = ["Prezes Zarządu", "Członek Zarządu", "Prokurent", "Pełnomocnik", "Wspólnik", "Inna funkcja"];

export function SignatoriesFields({ signatories, onChange, errors = {}, clearErr, max = 2, label = "Osoba (osoby) podpisująca umowę *", addLabel = "Dodaj osobę", defaultRole = "", showRepresents = false }) {
  const set = (i, patch) => onChange(signatories.map((s, j) => (j === i ? { ...s, ...patch } : s)));
  return (
    <div data-testid="order-signatories-section" className="space-y-3">
      <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-muted-foreground">{label}</p>
      {signatories.map((s, i) => (
        <div key={i} data-testid={`order-signatory-${i + 1}`} className="space-y-1">
          <div className="grid grid-cols-[auto_1fr] sm:grid-cols-[auto_1fr_minmax(10rem,1fr)_auto] gap-2 items-start">
            <span className="h-10 inline-flex items-center justify-center font-display font-bold text-sm text-muted-foreground w-5">{i + 1}.</span>
            <Input data-testid={`order-signatory-name-${i + 1}`} data-field={`sig_name_${i}`} aria-invalid={!!errors[`sig_name_${i}`]} placeholder="Imię i nazwisko" value={s.name} onChange={(e) => { set(i, { name: e.target.value }); clearErr?.(`sig_name_${i}`); }} className={`bg-background ${errCls(errors[`sig_name_${i}`])}`} />
            <Select value={s.role || ""} onValueChange={(v) => { set(i, { role: v }); clearErr?.(`sig_role_${i}`); }}>
              <SelectTrigger data-testid={`order-signatory-role-${i + 1}`} data-field={`sig_role_${i}`} aria-invalid={!!errors[`sig_role_${i}`]} className={`bg-background ${errCls(errors[`sig_role_${i}`])}`}>
                <SelectValue placeholder="Funkcja —" />
              </SelectTrigger>
              <SelectContent>
                {SIGNATORY_ROLES.map((r) => <SelectItem key={r} value={r} data-testid={`order-signatory-role-${i + 1}-option-${r}`}>{r}</SelectItem>)}
              </SelectContent>
            </Select>
            {i > 0 ? (
              <button type="button" data-testid={`order-signatory-remove-${i + 1}`} aria-label="Usuń osobę" onClick={() => onChange(signatories.filter((_, j) => j !== i))} className="h-10 w-10 rounded-full inline-flex items-center justify-center text-brand-red hover:bg-brand-red/10 transition-colors"><Trash2 size={15} /></button>
            ) : <span className="hidden sm:block w-10" aria-hidden />}
          </div>
          {showRepresents && (
            <label className="flex items-center gap-2 pl-7 cursor-pointer text-xs text-muted-foreground">
              <Checkbox data-testid={`order-signatory-represents-${i + 1}`} checked={!!s.represents} onCheckedChange={(v) => set(i, { represents: !!v })} />
              <span>Uprawniony do reprezentacji (podpisuje umowę w imieniu spółki)</span>
            </label>
          )}
          <FieldError id={`order-sig_name_${i}`} msg={errors[`sig_name_${i}`]} />
          <FieldError id={`order-sig_role_${i}`} msg={errors[`sig_role_${i}`]} />
        </div>
      ))}
      {signatories.length < max && (
        <button type="button" data-testid="order-signatory-add" onClick={() => onChange([...signatories, { name: "", role: defaultRole }])} className="inline-flex items-center gap-1.5 text-xs font-semibold text-brand-teal hover:text-brand-tealDark transition-colors">
          <Plus size={13} /> {addLabel}
        </button>
      )}
    </div>
  );
}
